// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProductPriceAlert_disabled{cursor:not-allowed}.ProductPriceAlert-Trigger{font-size:14px;color:var(--color-brand);display:block;cursor:pointer}.ProductPriceAlert-Trigger:hover{text-decoration:underline}@media (min-width: 768px){.ProductPriceAlert-Trigger{width:150px;font-size:16px;margin-top:10px}}.ProductPriceAlert_disabled .ProductPriceAlert-Trigger{color:var(--color-text);pointer-events:none}.ProductPriceAlert-Popup .Button{margin-top:35px;min-width:180px}\n", ""]);
// Exports
module.exports = exports;
